import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div className="home-page">
      <div className="home-page__header">
        {/* Place percyPriestLogo.png (or .svg) in client/public/ */}
        <img
          src="/percyPriestLogo.png"
          alt="The Percy Priest Branch of The Church of Jesus Christ of Latter-day Saints"
          className="home-page__logo"
        />
        <h1 className="home-page__title">Percy Priest Branch</h1>
        <p className="home-page__disclaimer">
          This is an unofficial site and is not endorsed by The Church of Jesus
          Christ of Latter-day Saints.
        </p>
      </div>

      <div className="home-page__sections">
        <Link to="/music" className="home-page__card">
          <div className="home-page__card-icon">♪</div>
          <h2 className="home-page__card-title">Music</h2>
          <p className="home-page__card-desc">
            Weekly schedule, pianists, and music coordination.
          </p>
        </Link>

        <Link to="/choir" className="home-page__card">
          <div className="home-page__card-icon">♬</div>
          <h2 className="home-page__card-title">Choir</h2>
          <p className="home-page__card-desc">
            Choir information and resources.
          </p>
        </Link>
      </div>
    </div>
  );
}
